<template>
    <div class="container">
        <img src="@/assets/logo.webp" alt="logo" />
        <p>
            {{ $i18n.locale === 'english' ? 'The requested URL was not found on this server' : '在此服务器上找不到请求的URL' }}
        </p>
    </div>
</template>

<script>
import { inserSeoElement } from '@/libs/utils'
export default {
    mounted() {
        inserSeoElement(this.$t('headSeo.notFoundTitle'))
    },
}
</script>

<style>
.container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
        margin-top: 100px;
        margin-bottom: 40px;
    }
    p{
        font-size: 24px;
        color: #020b3b;
        margin-bottom: 170px;
    }
}
</style>